import type { QuestionTranslateData } from '@repo/types/questions/QuestionTranslate';

import { Badge } from '@/components/ui/badge';

interface QuestionMarkedTranslateContentProps {
  question: QuestionTranslateData;
}

export function QuestionMarkedTranslateContent(questionMarkedTranslateContentProps: QuestionMarkedTranslateContentProps) {
  const { question } = questionMarkedTranslateContentProps;
  return (
    <div className="flex flex-wrap gap-1">
      {question.options.map((option) => (
        <Badge variant={'muted'} size={'sm'} key={option.id}>
          {option.content}
        </Badge>
      ))}
    </div>
  );
}
